import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { forwardRef } from 'react';

/**
 * This icon shouldn't be used for buttons.
 * In case you need clickable/hoverable color changing icon, use the IconButton component instead.
 * You CAN use it for showing tooltip on hover, but it shouldn't change it's styling on hover.
 * iconClass is the class name of the icon and should only identify the icon glyph.
 * @returns A span element with the icon.
 */
export const Icon = forwardRef<HTMLSpanElement, {
  iconClass: string;
  color?: string;
  'data-testid'?: string;
}>((t0, ref) => {
  const $ = _c(17);
  let color;
  let dataTestId;
  let iconClass;
  let rest;
  if ($[0] !== t0) {
    ({
      iconClass,
      color,
      "data-testid": dataTestId,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = color;
    $[2] = dataTestId;
    $[3] = iconClass;
    $[4] = rest;
  } else {
    color = $[1];
    dataTestId = $[2];
    iconClass = $[3];
    rest = $[4];
  }
  let t1;
  if ($[5] !== iconClass) {
    t1 = classNames(iconClass, "w-[20px] h-[20px]");
    $[5] = iconClass;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== color) {
    t2 = {
      color
    };
    $[7] = color;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t1 || $[10] !== t2) {
    t3 = <i className={t1} style={t2} />;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== dataTestId || $[13] !== ref || $[14] !== rest || $[15] !== t3) {
    t4 = <span {...rest} ref={ref} className="inline-flex w-[24px] h-[24px] p-[2px]" data-testid={dataTestId}>{t3}</span>;
    $[12] = dataTestId;
    $[13] = ref;
    $[14] = rest;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
});